import {BankState, NestedReadonly} from '@colonist/game-states'
import {CardValidatorUnordered} from './card/CardValidatorUnordered'

export class BankValidator {
    private readonly state: NestedReadonly<BankState>

    resourceCards: CardValidatorUnordered

    constructor(state: NestedReadonly<BankState>) {
        this.state = state
        this.resourceCards = new CardValidatorUnordered(this.state.resourceCards)
    }

    get hideBankCards(): boolean {
        return this.state.hideBankCards
    }
}
